"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSettings = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
exports.defaultSettings = {
    disabled: false,
    disableElevation: true,
    size: 'medium',
    type: 'button',
};
var ButtonComponent = function (props) {
    var button = react_redux_1.useSelector(crude_selector_1.getAppLayout).button;
    var startIcon = props.startIcon;
    var color = props.color ? props.color : undefined;
    var disabled = props.disabled ? props.disabled : exports.defaultSettings.disabled;
    var disableElevation = props.disableElevation ? props.disableElevation : exports.defaultSettings.disableElevation;
    var variant = props.variant ? props.variant : button === null || button === void 0 ? void 0 : button.type;
    var size = props.size ? props.size : exports.defaultSettings.size;
    var type = props.type ? props.type : exports.defaultSettings.type;
    var link = props.link ? props.link : '';
    return (react_1.default.createElement(material_1.Button, { style: props.styles, href: link, target: '_blank', color: color, variant: variant, type: type, size: size, disabled: disabled, disableElevation: disableElevation, startIcon: startIcon && ((typeof startIcon === 'string') ? react_1.default.createElement(material_1.Icon, { style: { textTransform: 'none' } }, startIcon) : startIcon), onClick: function () { return props.onClick && props.onClick(); } }, props.text));
};
exports.default = ButtonComponent;
